<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>代采订单报表详情</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <div
      v-if="resData"
      class="c_page-title"
      style="padding-bottom: 0; height: 40px"
    >
      <ul
        v-for="item in [resData.supply]"
        class="list-header"
        style="list-style: none; font-size: 14px"
      >
        <li>商家ID：{{ item.supply_id }}</li>
        <li>商家名称：{{ item.supply_name }}</li>
        <li>代采订单：{{ item.woid }}</li>
        <li>代采时间：{{ item.create_time }}</li>
        <li>市场：{{ item.market_name }}</li>
      </ul>
    </div>

    <div class="c_page-title" style="padding-bottom: 0; height: 80px">
      <el-row
        v-if="resData"
        class="row"
        :gutter="20"
        type="flex"
        align="middle"
        justify="space-around"
      >
        <el-col
          v-for="item in resData.order"
          :key="item.key"
          :span="24 / resData.order.length"
          class="column"
        >
          <div
            class="status"
            style="height: 60px; font-size: 14px; width: 120px"
            :class="{ active: type === item.key }"
            @click="selectStatus(item.key)"
          >
            <div>{{ item.label }}</div>
            <div>{{ item.num }} / {{ item.amount }}</div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 表格 -->
    <el-row>
      <div style="margin-top: 30px; padding-bottom: 15px; height: 35px">
        <el-col :span="2" style="margin-right: 20px">
          <el-input
            v-model="form.goods_kh"
            size="small"
            placeholder="款号"
            @keyup.native.enter="search"
          ></el-input>
        </el-col>
        <el-col :span="2" style="margin-right: 20px">
          <el-input
            v-model="form.goods_no"
            size="small"
            placeholder="货号"
            @keyup.native.enter="search"
          ></el-input>
        </el-col>
        <el-col :span="2" style="margin-right: 40px">
          <el-button size="small" type="primary" @click="search">
            查询</el-button
          >
        </el-col>
      </div>
      <el-col style="border: 1px solid #ddd">
        <div v-if="resData" style="margin-bottom: 0">
          <div
            style="
              background: #f3f3f3;
              height: 50px;
              line-height: 30px;
              padding: 0 25px;
              display: flex;
              align-items: center;
              position: relative;
            "
          >
            <div>
              数据统计: 共{{ resData.collect.num }}件，计{{
                resData.collect.amount
              }}
            </div>
            <div style="position: absolute; right: 0">
              <el-button size="small" type="success" @click="output">
                导出</el-button
              >
            </div>
          </div>
          <el-table
            v-if="type == 1"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column prop="goods_kh" label="款号" align="center">
            </el-table-column>
            <el-table-column prop="goods_no" label="货号" align="center">
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" align="center">
            </el-table-column>
            <el-table-column prop="brand_name" label="品牌" align="center">
            </el-table-column>
            <el-table-column prop="img" label="图片" align="center">
              <template slot-scope="scope">
                <div style="width: 70px; height: 85px; overflow: hidden">
                  <viewer class="viewer" :images="scope.row.imgs">
                    <img
                      v-for="src in scope.row.imgs"
                      :key="src"
                      :src="src"
                      style="width: 70px; height: 85px"
                    />
                  </viewer>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="co_val" label="颜色" align="center">
            </el-table-column>
            <el-table-column prop="si_val" label="尺码" align="center">
            </el-table-column>
            <el-table-column prop="price" label="代采单价" align="center">
            </el-table-column>
            <el-table-column prop="num" label="代采数量" align="center">
            </el-table-column>
            <el-table-column prop="create_time" label="开单时间" align="center">
            </el-table-column>
          </el-table>

          <el-table
            v-if="type == 2"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column prop="goods_kh" label="款号" align="center">
            </el-table-column>
            <el-table-column prop="goods_no" label="货号" align="center">
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" align="center">
            </el-table-column>
            <el-table-column prop="brand_name" label="品牌" align="center">
            </el-table-column>
            <el-table-column prop="img" label="图片" align="center">
              <template slot-scope="scope">
                <div style="width: 70px; height: 85px; overflow: hidden">
                  <viewer class="viewer" :images="scope.row.imgs">
                    <img
                      v-for="src in scope.row.imgs"
                      :key="src"
                      :src="src"
                      style="width: 70px; height: 85px"
                    />
                  </viewer>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="co_val" label="颜色" align="center">
            </el-table-column>
            <el-table-column prop="si_val" label="尺码" align="center">
            </el-table-column>
            <el-table-column prop="price" label="代采单价" align="center">
            </el-table-column>
            <el-table-column prop="num" label="入库数量" align="center">
            </el-table-column>
            <el-table-column
              prop="stock_in_record_where"
              label="库区"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="stock_in_record_status"
              label="状态"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="admin_name" label="入库人" align="center">
            </el-table-column>
            <el-table-column prop="create_time" label="入库时间" align="center">
            </el-table-column>
          </el-table>
          <el-table
            v-if="type == 3 || type == 4"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column prop="goods_kh" label="款号" align="center">
            </el-table-column>
            <el-table-column prop="goods_no" label="货号" align="center">
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" align="center">
            </el-table-column>
            <el-table-column prop="brand_name" label="品牌" align="center">
            </el-table-column>
            <el-table-column prop="img" label="图片" align="center">
              <template slot-scope="scope">
                <div style="width: 70px; height: 85px; overflow: hidden">
                  <viewer class="viewer" :images="scope.row.imgs">
                    <img
                      v-for="src in scope.row.imgs"
                      :key="src"
                      :src="src"
                      style="width: 70px; height: 85px"
                    />
                  </viewer>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="co_val" label="颜色" align="center">
            </el-table-column>
            <el-table-column prop="si_val" label="尺码" align="center">
            </el-table-column>
            <el-table-column prop="price" label="代采单价" align="center">
            </el-table-column>
            <el-table-column prop="num" label="欠货数量" align="center">
            </el-table-column>
            <el-table-column prop="create_time" label="生成时间" align="center">
            </el-table-column>
          </el-table>

          <el-table
            v-if="type == 5"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column prop="goods_kh" label="款号" align="center">
            </el-table-column>
            <el-table-column prop="goods_no" label="货号" align="center">
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" align="center">
            </el-table-column>
            <el-table-column prop="brand_name" label="品牌" align="center">
            </el-table-column>
            <el-table-column prop="img" label="图片" align="center">
              <template slot-scope="scope">
                <div style="width: 70px; height: 85px; overflow: hidden">
                  <viewer class="viewer" :images="scope.row.imgs">
                    <img
                      v-for="src in scope.row.imgs"
                      :key="src"
                      :src="src"
                      style="width: 70px; height: 85px"
                    />
                  </viewer>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="co_val" label="颜色" align="center">
            </el-table-column>
            <el-table-column prop="si_val" label="尺码" align="center">
            </el-table-column>
            <el-table-column prop="price" label="代采单价" align="center">
            </el-table-column>
            <el-table-column prop="num" label="代采数量" align="center">
            </el-table-column>
            <el-table-column
              prop="wcg_ded_status"
              label="抵扣状态"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="ded_price" label="抵扣金额" align="center">
            </el-table-column>
            <el-table-column prop="admin_name" label="操作人" align="center">
            </el-table-column>
            <el-table-column prop="create_time" label="操作时间" align="center">
            </el-table-column>
          </el-table>

          <el-table
            v-if="type == 6"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column prop="goods_kh" label="款号" align="center">
            </el-table-column>
            <el-table-column prop="goods_no" label="货号" align="center">
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" align="center">
            </el-table-column>
            <el-table-column prop="brand_name" label="品牌" align="center">
            </el-table-column>
            <el-table-column prop="img" label="图片" align="center">
              <template slot-scope="scope">
                <div style="width: 70px; height: 85px; overflow: hidden">
                  <viewer class="viewer" :images="scope.row.imgs">
                    <img
                      v-for="src in scope.row.imgs"
                      :key="src"
                      :src="src"
                      style="width: 70px; height: 85px"
                    />
                  </viewer>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="co_val" label="颜色" align="center">
            </el-table-column>
            <el-table-column prop="si_val" label="尺码" align="center">
            </el-table-column>
            <el-table-column prop="price" label="代采单价" align="center">
            </el-table-column>
            <el-table-column prop="num" label="代采数量" align="center">
            </el-table-column>
            <el-table-column
              prop="wcg_refund_status"
              label="状态"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="admin_name" label="操作人" align="center">
            </el-table-column>
            <el-table-column prop="create_time" label="操作时间" align="center">
            </el-table-column>
          </el-table>

          <el-table
            v-if="type == 7"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column prop="goods_kh" label="款号" align="center">
            </el-table-column>
            <el-table-column prop="goods_no" label="货号" align="center">
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" align="center">
            </el-table-column>
            <el-table-column prop="brand_name" label="品牌" align="center">
            </el-table-column>
            <el-table-column prop="img" label="图片" align="center">
              <template slot-scope="scope">
                <div style="width: 70px; height: 85px; overflow: hidden">
                  <viewer class="viewer" :images="scope.row.imgs">
                    <img
                      v-for="src in scope.row.imgs"
                      :key="src"
                      :src="src"
                      style="width: 70px; height: 85px"
                    />
                  </viewer>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="co_val" label="颜色" align="center">
            </el-table-column>
            <el-table-column prop="si_val" label="尺码" align="center">
            </el-table-column>
            <el-table-column prop="price" label="代采单价" align="center">
            </el-table-column>
            <el-table-column prop="num" label="结束数量" align="center">
            </el-table-column>
            <el-table-column prop="create_time" label="操作时间" align="center">
            </el-table-column>
          </el-table>
          <el-table
            v-if="type == 8"
            ref="multipleTable"
            :key="'tab3'"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column prop="bill_id" label="账单号" align="center">
            </el-table-column>
            <el-table-column prop="create_time" label="账单日期" align="center">
            </el-table-column>
            <el-table-column prop="goods_kh" label="款号" align="center">
            </el-table-column>
            <el-table-column prop="goods_no" label="货号" align="center">
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" align="center">
            </el-table-column>
            <el-table-column prop="brand_name" label="品牌" align="center">
            </el-table-column>
            <el-table-column prop="img" label="图片" align="center">
              <template slot-scope="scope">
                <div style="width: 70px; height: 85px; overflow: hidden">
                  <viewer class="viewer" :images="scope.row.imgs">
                    <img
                      v-for="src in scope.row.imgs"
                      :key="src"
                      :src="src"
                      style="width: 70px; height: 85px"
                    />
                  </viewer>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="co_val" label="颜色" align="center">
            </el-table-column>
            <el-table-column prop="si_val" label="尺码" align="center">
            </el-table-column>
            <el-table-column prop="price" label="代采单价" align="center">
            </el-table-column>
            <el-table-column prop="num" label="结账数量" align="center">
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      form: {
        data_type: 1,
      },
      loading: false,
      url: "/erp/SupplySettle/supplySettleReportDetail",
      type: 1,
      tableLoading: false,
      filterFold: false,
      multipleSelection: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      const { woid } = this.$route.params;
      this.form.woid = woid;
      return this.form;
    },
  },
  methods: {
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    fetchData() {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          return this.$message.error(res.data.msg);
        }
        this.resData = res.data.data;
      });
    },
    selectStatus(key) {
      this.form.data_type = key;
      this.type = key;
      this.fetchData();
    },
    search() {
      this.fetchData();
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.list-header li {
  float: left;
  padding-left: 0;
  font-size: 14px;
  color: #606266;
  margin-right: 30px;
  height: 40px;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/supplybill/ReportDetail.vue